import { render, staticRenderFns } from "./ConfirmSecondPSModal.vue?vue&type=template&id=007ceb7c&scoped=true"
import script from "./ConfirmSecondPSModal.vue?vue&type=script&lang=js"
export * from "./ConfirmSecondPSModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmSecondPSModal.vue?vue&type=style&index=0&id=007ceb7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007ceb7c",
  null
  
)

export default component.exports